import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { API } from './constants';
import { TransactionType } from '../models/transaction-types';

@Injectable({ providedIn: 'root' })
export class TransactionTypesService extends ApiService {
  getTransactionTypes() {
		return this.get<{ elements: TransactionType[] }>(API.getTransactionTypes);
  }
}
